{
  "expandControls": {
    "expand": "Развернуть",
    "collapse": "Свернуть",
    "expandRecursively": "Рекурсивно развернуть",
    "collapseRecursively": "Рекурсивно свернуть"
  }
}